/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {useCallback, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {showMovedDevices} from './state';
import {
  deviceMoveResultSelector,
  deviceMoveSelectedDevicesSelector,
  deviceMoveShowDialogSelector
} from './state-selectors';

/**
 * Custom hook for showing Snackbar for Moving Devices.
 */
export const useDeviceMove = () => {
  const dispatch = useDispatch();
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const movedDevices                  = useSelector(deviceMoveResultSelector);
  const showMoveDevice                = useSelector(deviceMoveShowDialogSelector);
  const selectedDevicesToMove         = useSelector(deviceMoveSelectedDevicesSelector);

  useEffect(() => {
    if (movedDevices && !showMoveDevice && !!selectedDevicesToMove?.length) {
      setShowSuccess(true);
    }
  }, [movedDevices]);
  
  const onCloseSnack = useCallback(() => {
    setShowSuccess(false);
  }, []);

  const onViewRecords = useCallback(() => {
    dispatch(showMovedDevices());
    setShowSuccess(false);
  }, []);

  const onCancelViewMovedDevicesDialog = useCallback(() => {
    dispatch(showMovedDevices(false));
  }, []);

  return {
    showSuccess,
    onCloseSnack,
    onViewRecords,
    onCancelViewMovedDevicesDialog,
    showMoveDevice,
    movedDevices
  };
};
